 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-01a6f5cf":"d3ac84e4","chunk-05622395":"ebc02461","chunk-05d1d9e0":"82237e76","chunk-0f7e77d8":"ba202674","chunk-1623e1a5":"63ca3d61","chunk-19b3313c":"0cf868b9","chunk-19c66bf4":"d62aad2d","chunk-2d216257":"97e7aa3f","chunk-0e385e6b":"5f5859ce","chunk-549de1a3":"4f4843ad","chunk-43d70600":"1153591d","chunk-289721fe":"b252bb6e","chunk-7a4c8b7a":"e32b2ebc","home":"cd7cf9f8","chunk-1a96b273":"da951575","chunk-1f1c4f86":"69a00d1d","chunk-24570e6f":"851531b4","chunk-6e714126":"9f363046","chunk-28adeed0":"1ca6c3ae","chunk-32babb2a":"c236f87f","chunk-3b779476":"d2e1e0c0","chunk-3bc23806":"b1790810","chunk-3f7104b2":"5167c332","chunk-04538a72":"a93cff5f","chunk-a4048ea8":"7928dbc8","chunk-4940aacc":"2742dc5e","chunk-4dbd773f":"91abdf98","chunk-4e400214":"545c7d52","chunk-4e459652":"390c968c","chunk-502240ad":"7a597aa5","chunk-549297ec":"8f0c5d87","chunk-5f526bd7":"089d12f6","chunk-639918d5":"705f1b52","chunk-63dfed7c":"5f91a8fd","chunk-6ccfbe62":"f78d09bc","chunk-6fac3796":"58b749bf","chunk-7d08c349":"8e1d9531","chunk-9bef7a30":"658f9643","chunk-b2b1da8e":"61e659cb","chunk-cbd9f0c0":"5c7b5987","chunk-dbaca29a":"771733f2","explain":"42156a27","feedback":"956cf510","switch":"4bdf1826","transfer":"dda68e70"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01a6f5cf":1,"chunk-05622395":1,"chunk-05d1d9e0":1,"chunk-0f7e77d8":1,"chunk-1623e1a5":1,"chunk-19b3313c":1,"chunk-0e385e6b":1,"chunk-549de1a3":1,"chunk-289721fe":1,"home":1,"chunk-1a96b273":1,"chunk-1f1c4f86":1,"chunk-24570e6f":1,"chunk-6e714126":1,"chunk-28adeed0":1,"chunk-32babb2a":1,"chunk-3b779476":1,"chunk-3bc23806":1,"chunk-3f7104b2":1,"chunk-04538a72":1,"chunk-a4048ea8":1,"chunk-4940aacc":1,"chunk-4dbd773f":1,"chunk-4e400214":1,"chunk-4e459652":1,"chunk-502240ad":1,"chunk-549297ec":1,"chunk-5f526bd7":1,"chunk-639918d5":1,"chunk-63dfed7c":1,"chunk-6ccfbe62":1,"chunk-6fac3796":1,"chunk-7d08c349":1,"chunk-9bef7a30":1,"chunk-b2b1da8e":1,"chunk-cbd9f0c0":1,"chunk-dbaca29a":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-01a6f5cf":"5d056bc4","chunk-05622395":"e0f85f4c","chunk-05d1d9e0":"c079a6ee","chunk-0f7e77d8":"ff789829","chunk-1623e1a5":"aa71ddb2","chunk-19b3313c":"631dae6a","chunk-19c66bf4":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-0e385e6b":"f8d72046","chunk-549de1a3":"379afd52","chunk-43d70600":"31d6cfe0","chunk-289721fe":"90118796","chunk-7a4c8b7a":"31d6cfe0","home":"3948cc19","chunk-1a96b273":"81341816","chunk-1f1c4f86":"1e2a6294","chunk-24570e6f":"6207f6e3","chunk-6e714126":"d14f8214","chunk-28adeed0":"12998b7c","chunk-32babb2a":"df58b423","chunk-3b779476":"44f8cb6c","chunk-3bc23806":"718a12bd","chunk-3f7104b2":"0f3d4798","chunk-04538a72":"f07a26c9","chunk-a4048ea8":"fd0919de","chunk-4940aacc":"fd30300f","chunk-4dbd773f":"08c6e550","chunk-4e400214":"ea9c9290","chunk-4e459652":"11e8d4ec","chunk-502240ad":"afaf6f49","chunk-549297ec":"1d87b3e2","chunk-5f526bd7":"e8b346b2","chunk-639918d5":"a336c4d8","chunk-63dfed7c":"ed059e09","chunk-6ccfbe62":"191e2c79","chunk-6fac3796":"ef0b93a1","chunk-7d08c349":"f9696fe4","chunk-9bef7a30":"b55e251a","chunk-b2b1da8e":"fc27cdeb","chunk-cbd9f0c0":"781d9fcf","chunk-dbaca29a":"c9695f78","explain":"de86fb25","feedback":"c4503ed6","switch":"5d5f3f9d","transfer":"3d35505d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
